<template>
  <button
    :title="title || label"
    :style="{
      writingMode: 'vertical-rl',
      transform: 'rotate(180deg)',
      padding: '12px 7px',
      background: 'transparent',
      border: 0,
      borderLeft: active ? '2px solid var(--p-primary-500)' : '2px solid transparent',
      color: active ? 'var(--p-text-color)' : 'var(--p-text-muted-color)',
      fontSize: '11px',
      fontWeight: 800,
      letterSpacing: '0.1em',
      textTransform: 'uppercase',
      lineHeight: 1,
      fontFamily: 'inherit',
      cursor: 'pointer',
      display: 'inline-flex',
      alignItems: 'center',
      gap: '9px',
    }"
    @click="emit('select', id)"
  >
    <i v-if="icon" :class="`pi pi-${icon}`" :style="{ fontSize: '13px', transform: 'rotate(90deg)' }" />
    <span>{{ label }}</span>
    <span
      v-if="badge != null && badge > 0"
      :style="{
        minWidth: '16px',
        height: '16px',
        padding: '0 4px',
        borderRadius: '999px',
        background: active ? 'var(--p-primary-500)' : 'var(--p-overlay-popover-background)',
        color: active ? 'var(--p-primary-950)' : 'var(--p-surface-400)',
        fontSize: '9.5px',
        fontWeight: 800,
        fontFamily: 'var(--p-font-mono)',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        letterSpacing: 0,
      }"
    >{{ badge }}</span>
  </button>
</template>

<script setup>
// Vertical tab (bottom-to-top text via writing-mode + rotation). Ported from
// list-edit-shell.jsx VTab. Emits select(id).
import { computed } from 'vue'

const props = defineProps({
  id: { type: String, required: true },
  current: { type: String, default: null },
  label: { type: String, default: '' },
  icon: { type: String, default: null },
  // A count beside the label. Rendered only when it is above zero.
  badge: { type: Number, default: null },
  title: { type: String, default: null },
})
const emit = defineEmits(['select'])
const active = computed(() => props.id === props.current)
</script>
